export const labOrdersDialogStyles = {
  paper: {
    width: 'calc(100% - 44px)',
    maxWidth: 1236,
    height: 'calc(100vh - 44px)',
    maxHeight: 622,
    minHeight: 520,
    m: 0,
    display: 'flex',
    flexDirection: 'column',
    borderRadius: '8px',
    bgcolor: '#FFFFFF',
    overflow: 'hidden',
    fontFamily: 'Roboto'
  },

  header: {
    minHeight: 76,
    px: 2,
    py: 1.25,
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E0E0E0',
    bgcolor: '#F8FAFD'
  },

  headerTitle: {
    color: '#424242',
    fontSize: 20,
    fontWeight: 500,
    lineHeight: 1.3
  },

  headerSubtitle: {
    mt: 0.25,
    color: '#424242',
    fontSize: 13,
    fontWeight: 400
  },

  closeButton: {
    mt: 0.25,
    width: 32,
    height: 32,
    color: '#424242',

    '&:hover': {
      bgcolor: '#EEEEEE'
    }
  },

  closeIcon: {
    fontSize: 22
  },

  content: {
    flex: '1 1 auto',
    minHeight: 0,
    p: '15px !important',
    overflowY: 'auto',
    overflowX: 'hidden',
    bgcolor: '#FFFFFF'
  },

  contentGrid: {
    minHeight: '100%',
    alignItems: 'flex-start'
  },

  leftColumn: {
    display: 'flex',
    flexDirection: 'column',
    gap: 1.5
  },

  panel: {
    width: '100%',
    border: '1px solid #DDDDDD',
    borderRadius: '8px',
    bgcolor: '#FFFFFF',
    overflow: 'hidden'
  },

  panelHeader: {
    minHeight: 40,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E0E0E0',
    bgcolor: '#FAFAFA'
  },

  panelTitle: {
    color: '#424242',
    fontSize: 16,
    fontWeight: 500
  },

  addButton: {
    width: 32,
    height: 32,
    p: 0,
    color: '#616161',

    '&:hover': {
      bgcolor: '#EEEEEE',
      color: '#1976D2'
    }
  },

  addIcon: {
    fontSize: 22
  },

  fieldWrapper: {
    p: 2
  },

  multilineField: {
    '& .MuiOutlinedInput-root': {
      minHeight: 120,
      alignItems: 'flex-start',
      borderRadius: '5px',
      bgcolor: '#FFFFFF',
      color: '#424242',
      fontSize: 14,

      '& fieldset': {
        borderColor: '#D9D9D9'
      },

      '&:hover fieldset': {
        borderColor: '#BDBDBD'
      },

      '&.Mui-focused fieldset': {
        borderColor: '#4A90D9'
      }
    },

    '& .MuiInputBase-inputMultiline': {
      p: 0
    },

    '& textarea::placeholder': {
      color: '#757575',
      opacity: 1
    }
  },

  pastDiagnosisPanel: {
    width: '100%',
    border: '1px solid #DDDDDD',
    borderRadius: '8px',
    bgcolor: '#FFFFFF',
    overflow: 'hidden'
  },

  tableContainer: {
    maxHeight: 340,
    overflowY: 'auto'
  },

  diagnosisTable: {
    tableLayout: 'fixed',

    '& .MuiTableCell-root': {
      height: 40,
      px: 1.5,
      py: 0,
      color: '#424242',
      fontSize: 13,
      borderBottom: '1px solid #E0E0E0'
    },

    '& .MuiTableBody-root .MuiTableRow-root:last-child .MuiTableCell-root': {
      borderBottom: 'none'
    }
  },

  actionCell: {
    width: 30,
    px: '10px !important'
  },

  codeCell: {
    width: 88,
    whiteSpace: 'nowrap'
  },

  diagnosisCell: {
    overflow: 'hidden'
  },

  diagnosisText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    color: '#424242',
    fontSize: 13
  },

 selectButton: {
  width: 20,
  height: 20,
  p: 0,
  minWidth: 20,
  color: '#4E8AC7',
  border: '1px solid #C1DEF2',
  borderRadius: '4px',
},

  selectIcon: {
    fontSize: 19
  },

  selectedRow: {
    bgcolor: '#FAFAFA'
  },

  footer: {
    flexShrink: 0,
    px: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 1.5,
    bgcolor: '#FFFFFF'
  },

  cancelButton: {
    color: '#424242',
    borderColor: '#D8D8D8',
    borderRadius: '4px',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:hover': {
      borderColor: '#BDBDBD',
      bgcolor: '#FAFAFA'
    }
  },

  signCloseButton: {
    color: '#424242',
    bgcolor: '#F5DDAE',
    border: '1px solid #E5C481',
    borderRadius: '4px',
    boxShadow: 'none',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:hover': {
      bgcolor: '#EFD092',
      boxShadow: 'none'
    },

    '&.Mui-disabled': {
      color: '#BDBDBD',
      bgcolor: '#EEEEEE',
      borderColor: '#EEEEEE'
    }
  },

  signPrintButton: {
    color: '#FFFFFF',
    bgcolor: '#5597D5',
    borderRadius: '4px',
    boxShadow: 'none',
    fontSize: 13,
    fontWeight: 500,
    textTransform: 'uppercase',

    '&:hover': {
      bgcolor: '#4386C5',
      boxShadow: 'none'
    },

    '&.Mui-disabled': {
      color: '#BDBDBD',
      bgcolor: '#EEEEEE'
    }
  },
  selectedDiagnosisList: {
  maxHeight: 220,
  overflowY: 'auto'
},

selectedDiagnosisRow: {
  alignItems: 'center',
  borderBottom: '1px solid #EEEEEE',
  display: 'grid',
  gridTemplateColumns: '25% 1fr 44px',
  minHeight: 40,
  px: 1.25,

  // '&:last-of-type': {
  //   borderBottom: 0
  // },

  '&:hover': {
    bgcolor: '#FCF8F2'
  }
},

selectedDiagnosisCode: {
  color: '#424242',
  fontSize: 13,
  fontWeight: 400
},

selectedDiagnosisDescription: {
  color: '#424242',
  fontSize: 13,
  fontWeight: 400,
  overflow: 'hidden',
  pr: 1,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
},

deleteDiagnosisButton: {
  color: '#757575',
  height: 20,
  justifySelf: 'center',
  width: 20,

},

deleteDiagnosisIcon: {
  fontSize: 18
},

emptyDiagnosisText: {
  alignItems: 'center',
  color: '#9E9E9E',
  display: 'flex',
  fontSize: 13,
  justifyContent: 'center',
  minHeight: 180,
  px: 2,
  textAlign: 'center'
}
};


